module.exports = __webpack_public_path__ + "img/civilization.b420352a.png";